module.exports = __webpack_public_path__ + "img/6.387c15ef.jpg";